export const format = (price: number) => (price / 100).toLocaleString();
